module.exports = __webpack_public_path__ + "static/img/hh2.9b724e4d.png";